import {Units} from '../../../../components/Forms/Constants/CommonESGConstants/constants';
import {
  energyManagementKeyLabel,
  energyManagementHeading,
  waterManagerKeyLabel,
  waterManagerHeading,
  managementTenantHeading,
  managementTenantKeyLabel,
  climateChangeHeading,
  climateChangeKeyLabel
} from '../../../../components/Forms/Constants/realEstate/questionKeyLabel';
import {inputType} from '../../interface/inputType';

/* eslint-disable no-console */
/* eslint-disable max-len */
export const energyManagement = [
  {
    key: '1',
    kpiId: 'IF-RE-130a.1',
    label:
      'Energy consumption data coverage as a percentage of total floor area, by property sector',
    items: [
      {
        field: [
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: energyManagementKeyLabel.Q1.key,
                  fieldLabel: energyManagementKeyLabel.Q1.lab
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: energyManagementKeyLabel.Q2.key,
                  fieldLabel: energyManagementKeyLabel.Q2.lab
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldLabel: energyManagementKeyLabel.Q3.lab,
                  fieldName: energyManagementKeyLabel.Q3.key,
                  relatedKey: [
                    energyManagementKeyLabel.Q1.key,
                    energyManagementKeyLabel.Q2.key
                  ],
                  formula: ([grossArea, totalGross]: any[]):
                    | number
                    | string => {
                    return (grossArea / totalGross) * 100;
                  },
                  units: '%'
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    key: '2',
    kpiId: 'IF-RE-130a.2',
    label: 'Property sector',
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: energyManagementHeading.HEADING_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: energyManagementKeyLabel.Q4.key,
            fieldLabel: energyManagementKeyLabel.Q4.lab,
            tooltip: energyManagementKeyLabel.Q4.tooltip,
            units: Units.Gigajoules,
            colSpan: true
          },
          {
            fieldType: inputType.HEADING_3,
            heading: energyManagementHeading.HEADING_2
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: energyManagementKeyLabel.Q5.key,
                  fieldLabel: energyManagementKeyLabel.Q5.lab
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: energyManagementKeyLabel.Q6.key,
                  fieldLabel: energyManagementKeyLabel.Q6.lab
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldLabel: energyManagementKeyLabel.Q7.lab,
                  fieldName: energyManagementKeyLabel.Q7.key,
                  relatedKey: [
                    energyManagementKeyLabel.Q5.key,
                    energyManagementKeyLabel.Q6.key
                  ],
                  formula: ([purchased, totalConsumed]: any[]):
                    | number
                    | string => {
                    return (purchased / totalConsumed) * 100;
                  },
                  units: '%'
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: energyManagementHeading.HEADING_3
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: energyManagementKeyLabel.Q8.key,
                  fieldLabel: energyManagementKeyLabel.Q8.lab
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: energyManagementKeyLabel.Q9.key,
                  fieldLabel: energyManagementKeyLabel.Q9.lab
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldLabel: energyManagementKeyLabel.Q10.lab,
                  fieldName: energyManagementKeyLabel.Q10.key,
                  relatedKey: [
                    energyManagementKeyLabel.Q8.key,
                    energyManagementKeyLabel.Q9.key
                  ],
                  formula: ([consumed, totalConsumed]: any[]):
                    | number
                    | string => {
                    return (consumed / totalConsumed) * 100;
                  },
                  units: '%'
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    key: '3',
    kpiId: 'IF-RE-130a.3',
    label:
      'Like-for-like percentage change in energy consumption for the portfolio area with data coverage, by property sector',
    items: [
      {
        field: [
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: energyManagementKeyLabel.Q11.key,
                  fieldLabel: energyManagementKeyLabel.Q11.lab
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: energyManagementKeyLabel.Q12.key,
                  fieldLabel: energyManagementKeyLabel.Q12.lab
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: energyManagementKeyLabel.Q13.key,
                  fieldLabel: energyManagementKeyLabel.Q13.lab,
                  relatedKey: [
                    energyManagementKeyLabel.Q11.key,
                    energyManagementKeyLabel.Q12.key
                  ],
                  formula: ([purchased, totalConsumed]: any[]):
                    | number
                    | string => {
                    return (purchased / totalConsumed) * 100;
                  },
                  units: '%'
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    key: '4',
    kpiId: 'IF-RE-130a.4',
    label: '',
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: energyManagementHeading.HEADING_4
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: energyManagementKeyLabel.Q14.key,
                  fieldLabel: energyManagementKeyLabel.Q14.lab
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: energyManagementKeyLabel.Q15.key,
                  fieldLabel: energyManagementKeyLabel.Q15.lab
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: energyManagementKeyLabel.Q16.key,
                  fieldLabel: energyManagementKeyLabel.Q16.lab,
                  relatedKey: [
                    energyManagementKeyLabel.Q14.key,
                    energyManagementKeyLabel.Q15.key
                  ],
                  formula: ([purchased, totalConsumed]: any[]):
                    | number
                    | string => {
                    return (purchased / totalConsumed) * 100;
                  },
                  units: '%'
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: energyManagementHeading.HEADING_5
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: energyManagementKeyLabel.Q17.key,
                  fieldLabel: energyManagementKeyLabel.Q17.lab
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: energyManagementKeyLabel.Q18.key,
                  fieldLabel: energyManagementKeyLabel.Q18.lab
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: energyManagementKeyLabel.Q19.key,

                  fieldLabel: energyManagementKeyLabel.Q19.lab,
                  relatedKey: [
                    energyManagementKeyLabel.Q17.key,
                    energyManagementKeyLabel.Q18.key
                  ],
                  formula: ([purchased, totalConsumed]: any[]):
                    | number
                    | string => {
                    return (purchased / totalConsumed) * 100;
                  },
                  units: '%'
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    key: '5',
    kpiId: 'IF-RE-130a.5',
    label: '',
    items: [
      {
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: energyManagementKeyLabel?.Q20.key,
            fieldLabel: energyManagementKeyLabel?.Q20.lab,
            colSpan: true
          }
        ]
      }
    ]
  }
];

export const waterManager = [
  {
    key: '1',
    kpiId: 'IF-RE-140a.1',
    label: '',
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: waterManagerHeading.HEADING_1
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: waterManagerKeyLabel.Q1.key,
                  fieldLabel: waterManagerKeyLabel.Q1.lab
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: waterManagerKeyLabel.Q2.key,
                  fieldLabel: waterManagerKeyLabel.Q2.lab
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: waterManagerKeyLabel.Q3.key,

                  fieldLabel: waterManagerKeyLabel.Q3.lab,
                  relatedKey: [
                    waterManagerKeyLabel.Q1.key,
                    waterManagerKeyLabel.Q2.key
                  ],
                  formula: ([grossArea, totalGross]: any[]):
                    | number
                    | string => {
                    return (grossArea / totalGross) * 100;
                  },
                  units: '%'
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: waterManagerHeading.HEADING_2
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: waterManagerKeyLabel.Q4.key,
                  fieldLabel: waterManagerKeyLabel.Q4.lab
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: waterManagerKeyLabel.Q5.key,
                  fieldLabel: waterManagerKeyLabel.Q5.lab
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: waterManagerKeyLabel.Q6.key,

                  fieldLabel: waterManagerKeyLabel.Q6.lab,
                  relatedKey: [
                    waterManagerKeyLabel.Q4.key,
                    waterManagerKeyLabel.Q5.key
                  ],
                  formula: ([grossArea, totalGross]: any[]):
                    | number
                    | string => {
                    return (grossArea / totalGross) * 100;
                  },
                  units: '%'
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    key: '2',
    kpiId: 'IF-RE-140a.2',
    label: '',
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: waterManagerHeading.HEADING_3
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: waterManagerKeyLabel?.Q7.key,
            fieldLabel: waterManagerKeyLabel?.Q7.lab,
            tooltip: waterManagerKeyLabel?.Q7.tooltip,
            colSpan: true,
            unit: Units?.m_3
          },
          {
            fieldType: inputType.HEADING_3,
            heading: waterManagerHeading.HEADING_4
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: waterManagerKeyLabel.Q8.key,
                  fieldLabel: waterManagerKeyLabel.Q8.lab
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: waterManagerKeyLabel.Q9.key,
                  fieldLabel: waterManagerKeyLabel.Q9.lab
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: waterManagerKeyLabel.Q10.key,

                  fieldLabel: waterManagerKeyLabel.Q10.lab,
                  relatedKey: [
                    waterManagerKeyLabel.Q8.key,
                    waterManagerKeyLabel.Q9.key
                  ],
                  formula: ([grossArea, totalGross]: any[]):
                    | number
                    | string => {
                    return (grossArea / totalGross) * 100;
                  },
                  units: '%'
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    key: '3',
    kpiId: 'IF-RE-140a.3',
    label:
      'Like-for-like percentage change in water withdrawn for portfolio area with data coverage, by property sector',
    items: [
      {
        field: [
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: waterManagerKeyLabel.Q11.key,
                  fieldLabel: waterManagerKeyLabel.Q11.lab
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: waterManagerKeyLabel.Q12.key,
                  fieldLabel: waterManagerKeyLabel.Q12.lab
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: waterManagerKeyLabel.Q13.key,
                  fieldLabel: waterManagerKeyLabel.Q13.lab,
                  relatedKey: [
                    waterManagerKeyLabel.Q11.key,
                    waterManagerKeyLabel.Q12.key
                  ],
                  formula: ([purchased, totalConsumed]: any[]):
                    | number
                    | string => {
                    const total = purchased / totalConsumed;

                    return (total - 1) * 100;
                  }
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    key: '4',
    kpiId: 'IF-RE-140a.4',
    label: '',
    items: [
      {
        field: [
          {
            fieldType: inputType.TEXT,
            fieldName: waterManagerKeyLabel?.Q14.key,
            fieldLabel: waterManagerKeyLabel?.Q14.lab,
            tooltip: waterManagerKeyLabel?.Q14.tooltip,
            colSpan: true
          }
        ]
      }
    ]
  }
];

export const managementTenant = [
  {
    key: '1',
    kpiId: 'IF-RE-410a.1',
    label: '',
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: managementTenantHeading.HEADING_1
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: managementTenantKeyLabel.Q1.key,
                  fieldLabel: managementTenantKeyLabel.Q1.lab
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: managementTenantKeyLabel.Q2.key,
                  fieldLabel: managementTenantKeyLabel.Q2.lab
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: managementTenantKeyLabel.Q3.key,

                  fieldLabel: managementTenantKeyLabel.Q3.lab,
                  relatedKey: [
                    managementTenantKeyLabel.Q1.key,
                    managementTenantKeyLabel.Q2.key
                  ],
                  formula: ([grossArea, totalGross]: any[]):
                    | number
                    | string => {
                    return (grossArea / totalGross) * 100;
                  },
                  units: '%'
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: managementTenantHeading.HEADING_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: managementTenantKeyLabel?.Q4.key,
            fieldLabel: managementTenantKeyLabel?.Q4.lab,
            tooltip: managementTenantKeyLabel?.Q4.tooltip,
            colSpan: true,
            unit: Units?.m_3
          }
        ]
      }
    ]
  },
  {
    key: '2',
    kpiId: 'IF-RE-410a.2',
    label: '',
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: managementTenantHeading.HEADING_3
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: managementTenantKeyLabel.Q5.key,
                  fieldLabel: managementTenantKeyLabel.Q5.lab
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: managementTenantKeyLabel.Q6.key,
                  fieldLabel: managementTenantKeyLabel.Q6.lab
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldLabel: managementTenantKeyLabel.Q7.lab,
                  fieldName: managementTenantKeyLabel.Q7.key,
                  relatedKey: [
                    managementTenantKeyLabel.Q5.key,
                    managementTenantKeyLabel.Q6.key
                  ],
                  formula: ([grossArea, totalGross]: any[]):
                    | number
                    | string => {
                    return (grossArea / totalGross) * 100;
                  },
                  units: '%'
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: managementTenantHeading.HEADING_4
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: managementTenantKeyLabel.Q8.key,
                  fieldLabel: managementTenantKeyLabel.Q8.lab
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: managementTenantKeyLabel.Q9.key,
                  fieldLabel: managementTenantKeyLabel.Q9.lab
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldLabel: managementTenantKeyLabel.Q10.lab,
                  relatedKey: [
                    managementTenantKeyLabel.Q8.key,
                    managementTenantKeyLabel.Q9.key
                  ],
                  formula: ([grossArea, totalGross]: any[]):
                    | number
                    | string => {
                    return (grossArea / totalGross) * 100;
                  },
                  units: '%'
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    key: '3',
    kpiId: 'IF-RE-410a.3',
    label:
      'Like-for-like percentage change in water withdrawn for portfolio area with data coverage, by property sector',
    items: [
      {
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: managementTenantKeyLabel?.Q11.key,
            fieldLabel: managementTenantKeyLabel?.Q11.lab,
            tooltip: managementTenantKeyLabel?.Q11.tooltip,
            colSpan: true
          }
        ]
      }
    ]
  }
];

export const climateChangeQ = [
  {
    key: '1',
    kpiId: 'IF-RE-450a.1',
    label: '',
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: climateChangeHeading.HEADING_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: climateChangeKeyLabel?.Q1.key,
            fieldLabel: climateChangeKeyLabel?.Q1.lab,
            tooltip: climateChangeKeyLabel?.Q1.tooltip,
            colSpan: true,
            unit: Units.m_3
          }
        ]
      }
    ]
  },
  {
    key: '2',
    kpiId: 'IF-RE-450a.2',
    label: '',
    items: [
      {
        field: [
          {
            fieldType: inputType.TEXT,
            fieldName: climateChangeKeyLabel?.Q2.key,
            fieldLabel: climateChangeKeyLabel?.Q2.lab,
            tooltip: climateChangeKeyLabel?.Q2.tooltip,
            colSpan: true
          }
        ]
      }
    ]
  }
];
